<script>
import {getDataProviders, getAssetClasses} from '@/helpers'

export default {

  data () {
    return {
      loading: false,
      benchmarkLoading: false,
      data: {

      },
      error: null,
      dataProviders: [],
      assetClassses: [],
      benchmarks: [],
      benchmark: null,
      assetClass: null,
      dataProvider: null,
    }
  },
  mounted () {
    getDataProviders().then((response) => {
      this.dataProviders = response.data.data
    })
    getAssetClasses().then((response) => {
      this.assetClassses = response.data.data
    })
  },
  methods: {
    findBenchmark (query) {
      this.benchmarkLoading = true
      this.$http.get('/tickers?filters[]=benchmark&search=' + query).then((response) => {
        this.benchmarks = response.data.data
        this.benchmarkLoading = false
      })
    },

    add () {
      this.loading = true
      this.$http.post('/tickers', this.data)
          .then((response) => {
            this.loading = false
            this.error = false
            this.$emit('created', response)
          }).catch((error) => {
            this.loading = false
            if (error.response && error.response.data && error.response.data.errors) {
              this.error = error.response.data
            }
            this.$emit('save-fail', error)
          })
    },
  },
}
</script>
